export interface CountryPhoneInfo {
  name: string;
  iso2: string; // Lowercase 2-letter ISO code e.g. 'us', 'gb', 'bd'
  dialCode: string; // e.g. '+1', '+44', '+880'
  flag: string; // Emoji flag e.g. '🇺🇸'
  popular?: boolean;
}

export const COUNTRIES_WITH_PHONE: CountryPhoneInfo[] = [
  // Popular / High-frequency
  { name: 'United States', iso2: 'us', dialCode: '+1', flag: '🇺🇸', popular: true },
  { name: 'United Kingdom', iso2: 'gb', dialCode: '+44', flag: '🇬🇧', popular: true },
  { name: 'Canada', iso2: 'ca', dialCode: '+1', flag: '🇨🇦', popular: true },
  { name: 'Australia', iso2: 'au', dialCode: '+61', flag: '🇦🇺', popular: true },
  { name: 'Bangladesh', iso2: 'bd', dialCode: '+880', flag: '🇧🇩', popular: true },
  { name: 'India', iso2: 'in', dialCode: '+91', flag: '🇮🇳', popular: true },
  { name: 'Germany', iso2: 'de', dialCode: '+49', flag: '🇩🇪', popular: true },
  { name: 'France', iso2: 'fr', dialCode: '+33', flag: '🇫🇷', popular: true },
  { name: 'United Arab Emirates', iso2: 'ae', dialCode: '+971', flag: '🇦🇪', popular: true },
  { name: 'Saudi Arabia', iso2: 'sa', dialCode: '+966', flag: '🇸🇦', popular: true },
  { name: 'Italy', iso2: 'it', dialCode: '+39', flag: '🇮🇹', popular: true },
  { name: 'Spain', iso2: 'es', dialCode: '+34', flag: '🇪🇸', popular: true },
  { name: 'Netherlands', iso2: 'nl', dialCode: '+31', flag: '🇳🇱', popular: true },
  { name: 'Sweden', iso2: 'se', dialCode: '+46', flag: '🇸🇪', popular: true },
  { name: 'Switzerland', iso2: 'ch', dialCode: '+41', flag: '🇨🇭', popular: true },
  { name: 'Singapore', iso2: 'sg', dialCode: '+65', flag: '🇸🇬', popular: true },
  { name: 'Malaysia', iso2: 'my', dialCode: '+60', flag: '🇲🇾', popular: true },
  { name: 'Pakistan', iso2: 'pk', dialCode: '+92', flag: '🇵🇰', popular: true },

  // Comprehensive World Countries
  { name: 'Afghanistan', iso2: 'af', dialCode: '+93', flag: '🇦🇫' },
  { name: 'Albania', iso2: 'al', dialCode: '+355', flag: '🇦🇱' },
  { name: 'Algeria', iso2: 'dz', dialCode: '+213', flag: '🇩🇿' },
  { name: 'Andorra', iso2: 'ad', dialCode: '+376', flag: '🇦🇩' },
  { name: 'Angola', iso2: 'ao', dialCode: '+244', flag: '🇦🇴' },
  { name: 'Argentina', iso2: 'ar', dialCode: '+54', flag: '🇦🇷' },
  { name: 'Armenia', iso2: 'am', dialCode: '+374', flag: '🇦🇲' },
  { name: 'Austria', iso2: 'at', dialCode: '+43', flag: '🇦🇹' },
  { name: 'Azerbaijan', iso2: 'az', dialCode: '+994', flag: '🇦🇿' },
  { name: 'Bahamas', iso2: 'bs', dialCode: '+1242', flag: '🇧🇸' },
  { name: 'Bahrain', iso2: 'bh', dialCode: '+973', flag: '🇧🇭' },
  { name: 'Barbados', iso2: 'bb', dialCode: '+1246', flag: '🇧🇧' },
  { name: 'Belarus', iso2: 'by', dialCode: '+375', flag: '🇧🇾' },
  { name: 'Belgium', iso2: 'be', dialCode: '+32', flag: '🇧🇪' },
  { name: 'Belize', iso2: 'bz', dialCode: '+501', flag: '🇧🇿' },
  { name: 'Benin', iso2: 'bj', dialCode: '+229', flag: '🇧🇯' },
  { name: 'Bhutan', iso2: 'bt', dialCode: '+975', flag: '🇧🇹' },
  { name: 'Bolivia', iso2: 'bo', dialCode: '+591', flag: '🇧🇴' },
  { name: 'Bosnia and Herzegovina', iso2: 'ba', dialCode: '+387', flag: '🇧🇦' },
  { name: 'Botswana', iso2: 'bw', dialCode: '+267', flag: '🇧🇼' },
  { name: 'Brazil', iso2: 'br', dialCode: '+55', flag: '🇧🇷' },
  { name: 'Brunei', iso2: 'bn', dialCode: '+673', flag: '🇧🇳' },
  { name: 'Bulgaria', iso2: 'bg', dialCode: '+359', flag: '🇧🇬' },
  { name: 'Burkina Faso', iso2: 'bf', dialCode: '+226', flag: '🇧🇫' },
  { name: 'Cambodia', iso2: 'kh', dialCode: '+855', flag: '🇰🇭' },
  { name: 'Cameroon', iso2: 'cm', dialCode: '+237', flag: '🇨🇲' },
  { name: 'Chile', iso2: 'cl', dialCode: '+56', flag: '🇨🇱' },
  { name: 'China', iso2: 'cn', dialCode: '+86', flag: '🇨🇳' },
  { name: 'Colombia', iso2: 'co', dialCode: '+57', flag: '🇨🇴' },
  { name: 'Costa Rica', iso2: 'cr', dialCode: '+506', flag: '🇨🇷' },
  { name: 'Croatia', iso2: 'hr', dialCode: '+385', flag: '🇭🇷' },
  { name: 'Cyprus', iso2: 'cy', dialCode: '+357', flag: '🇨🇾' },
  { name: 'Czech Republic', iso2: 'cz', dialCode: '+420', flag: '🇨🇿' },
  { name: 'Denmark', iso2: 'dk', dialCode: '+45', flag: '🇩🇰' },
  { name: 'Dominican Republic', iso2: 'do', dialCode: '+1809', flag: '🇩🇴' },
  { name: 'Ecuador', iso2: 'ec', dialCode: '+593', flag: '🇪🇨' },
  { name: 'Egypt', iso2: 'eg', dialCode: '+20', flag: '🇪🇬' },
  { name: 'El Salvador', iso2: 'sv', dialCode: '+503', flag: '🇸🇻' },
  { name: 'Estonia', iso2: 'ee', dialCode: '+372', flag: '🇪🇪' },
  { name: 'Ethiopia', iso2: 'et', dialCode: '+251', flag: '🇪🇹' },
  { name: 'Finland', iso2: 'fi', dialCode: '+358', flag: '🇫🇮' },
  { name: 'Georgia', iso2: 'ge', dialCode: '+995', flag: '🇬🇪' },
  { name: 'Ghana', iso2: 'gh', dialCode: '+233', flag: '🇬🇭' },
  { name: 'Greece', iso2: 'gr', dialCode: '+30', flag: '🇬🇷' },
  { name: 'Guatemala', iso2: 'gt', dialCode: '+502', flag: '🇬🇹' },
  { name: 'Honduras', iso2: 'hn', dialCode: '+504', flag: '🇭🇳' },
  { name: 'Hong Kong', iso2: 'hk', dialCode: '+852', flag: '🇭🇰' },
  { name: 'Hungary', iso2: 'hu', dialCode: '+36', flag: '🇭🇺' },
  { name: 'Iceland', iso2: 'is', dialCode: '+354', flag: '🇮🇸' },
  { name: 'Indonesia', iso2: 'id', dialCode: '+62', flag: '🇮🇩' },
  { name: 'Iraq', iso2: 'iq', dialCode: '+964', flag: '🇮🇶' },
  { name: 'Ireland', iso2: 'ie', dialCode: '+353', flag: '🇮🇪' },
  { name: 'Israel', iso2: 'il', dialCode: '+972', flag: '🇮🇱' },
  { name: 'Jamaica', iso2: 'jm', dialCode: '+1876', flag: '🇯🇲' },
  { name: 'Japan', iso2: 'jp', dialCode: '+81', flag: '🇯🇵' },
  { name: 'Jordan', iso2: 'jo', dialCode: '+962', flag: '🇯🇴' },
  { name: 'Kazakhstan', iso2: 'kz', dialCode: '+7', flag: '🇰🇿' },
  { name: 'Kenya', iso2: 'ke', dialCode: '+254', flag: '🇰🇪' },
  { name: 'Kuwait', iso2: 'kw', dialCode: '+965', flag: '🇰🇼' },
  { name: 'Latvia', iso2: 'lv', dialCode: '+371', flag: '🇱🇻' },
  { name: 'Lebanon', iso2: 'lb', dialCode: '+961', flag: '🇱🇧' },
  { name: 'Lithuania', iso2: 'lt', dialCode: '+370', flag: '🇱🇹' },
  { name: 'Luxembourg', iso2: 'lu', dialCode: '+352', flag: '🇱🇺' },
  { name: 'Maldives', iso2: 'mv', dialCode: '+960', flag: '🇲🇻' },
  { name: 'Malta', iso2: 'mt', dialCode: '+356', flag: '🇲🇹' },
  { name: 'Mexico', iso2: 'mx', dialCode: '+52', flag: '🇲🇽' },
  { name: 'Moldova', iso2: 'md', dialCode: '+373', flag: '🇲🇩' },
  { name: 'Monaco', iso2: 'mc', dialCode: '+377', flag: '🇲🇨' },
  { name: 'Morocco', iso2: 'ma', dialCode: '+212', flag: '🇲🇦' },
  { name: 'Nepal', iso2: 'np', dialCode: '+977', flag: '🇳🇵' },
  { name: 'New Zealand', iso2: 'nz', dialCode: '+64', flag: '🇳🇿' },
  { name: 'Nigeria', iso2: 'ng', dialCode: '+234', flag: '🇳🇬' },
  { name: 'Norway', iso2: 'no', dialCode: '+47', flag: '🇳🇴' },
  { name: 'Oman', iso2: 'om', dialCode: '+968', flag: '🇴🇲' },
  { name: 'Panama', iso2: 'pa', dialCode: '+507', flag: '🇵🇦' },
  { name: 'Paraguay', iso2: 'py', dialCode: '+595', flag: '🇵🇾' },
  { name: 'Peru', iso2: 'pe', dialCode: '+51', flag: '🇵🇪' },
  { name: 'Philippines', iso2: 'ph', dialCode: '+63', flag: '🇵🇭' },
  { name: 'Poland', iso2: 'pl', dialCode: '+48', flag: '🇵🇱' },
  { name: 'Portugal', iso2: 'pt', dialCode: '+351', flag: '🇵🇹' },
  { name: 'Qatar', iso2: 'qa', dialCode: '+974', flag: '🇶🇦' },
  { name: 'Romania', iso2: 'ro', dialCode: '+40', flag: '🇷🇴' },
  { name: 'Russia', iso2: 'ru', dialCode: '+7', flag: '🇷🇺' },
  { name: 'Senegal', iso2: 'sn', dialCode: '+221', flag: '🇸🇳' },
  { name: 'Serbia', iso2: 'rs', dialCode: '+381', flag: '🇷🇸' },
  { name: 'Slovakia', iso2: 'sk', dialCode: '+421', flag: '🇸🇰' },
  { name: 'Slovenia', iso2: 'si', dialCode: '+386', flag: '🇸🇮' },
  { name: 'South Africa', iso2: 'za', dialCode: '+27', flag: '🇿🇦' },
  { name: 'South Korea', iso2: 'kr', dialCode: '+82', flag: '🇰🇷' },
  { name: 'Sri Lanka', iso2: 'lk', dialCode: '+94', flag: '🇱🇰' },
  { name: 'Thailand', iso2: 'th', dialCode: '+66', flag: '🇹🇭' },
  { name: 'Tunisia', iso2: 'tn', dialCode: '+216', flag: '🇹🇳' },
  { name: 'Turkey', iso2: 'tr', dialCode: '+90', flag: '🇹🇷' },
  { name: 'Ukraine', iso2: 'ua', dialCode: '+380', flag: '🇺🇦' },
  { name: 'Uruguay', iso2: 'uy', dialCode: '+598', flag: '🇺🇾' },
  { name: 'Uzbekistan', iso2: 'uz', dialCode: '+998', flag: '🇺🇿' },
  { name: 'Venezuela', iso2: 've', dialCode: '+58', flag: '🇻🇪' },
  { name: 'Vietnam', iso2: 'vn', dialCode: '+84', flag: '🇻🇳' },
  { name: 'Global / Other', iso2: '', dialCode: '+1', flag: '🌐' }
];

// Helper to normalize country input
export function resolveCountryPhoneInfo(countryStr: string): CountryPhoneInfo {
  if (!countryStr) return COUNTRIES_WITH_PHONE[0];
  const query = countryStr.trim().toLowerCase();

  // Direct ISO match
  const byIso = COUNTRIES_WITH_PHONE.find(c => c.iso2 === query);
  if (byIso) return byIso;

  // Direct Name match
  const byName = COUNTRIES_WITH_PHONE.find(c => c.name.toLowerCase() === query);
  if (byName) return byName;

  // Common aliases
  if (query === 'usa' || query === 'us' || query === 'united states of america') {
    return COUNTRIES_WITH_PHONE[0];
  }
  if (query === 'uk' || query === 'gb' || query === 'great britain' || query === 'england') {
    return COUNTRIES_WITH_PHONE[1];
  }
  if (query === 'uae' || query === 'dubai') {
    return COUNTRIES_WITH_PHONE.find(c => c.iso2 === 'ae') || COUNTRIES_WITH_PHONE[0];
  }
  if (query === 'bd' || query === 'bangla') {
    return COUNTRIES_WITH_PHONE.find(c => c.iso2 === 'bd') || COUNTRIES_WITH_PHONE[0];
  }

  // Partial match
  const partial = COUNTRIES_WITH_PHONE.find(c => c.name.toLowerCase().includes(query) || query.includes(c.name.toLowerCase()));
  if (partial) return partial;

  return COUNTRIES_WITH_PHONE[0];
}

export interface PhoneValidationResult {
  isValid: boolean;
  errorMessage?: string;
  cleanedFullNumber?: string;
  nationalNumber?: string;
}

export function getPhonePlaceholderForCountry(countryStr: string): string {
  const info = resolveCountryPhoneInfo(countryStr);
  const iso = info.iso2;
  if (iso === 'us' || iso === 'ca') return 'e.g. 202-555-0143';
  if (iso === 'bd') return 'e.g. 01712-345678';
  if (iso === 'gb') return 'e.g. 07911 123456';
  if (iso === 'in') return 'e.g. 98765 43210';
  if (iso === 'ae') return 'e.g. 50 123 4567';
  if (iso === 'sa') return 'e.g. 51 234 5678';
  if (iso === 'au') return 'e.g. 0412 345 678';
  if (iso === 'de') return 'e.g. 151 23456789';
  if (iso === 'fr') return 'e.g. 06 12 34 56 78';
  return 'e.g. Mobile number';
}

export function validatePhoneNumberForCountry(phone: string, countryName: string): PhoneValidationResult {
  if (!phone || !phone.trim()) {
    return {
      isValid: false,
      errorMessage: 'Phone number is required.'
    };
  }

  const countryInfo = resolveCountryPhoneInfo(countryName);
  const raw = phone.trim();

  // Extract all digits
  const allDigits = raw.replace(/\D/g, '');
  const dialDigits = countryInfo.dialCode.replace(/\D/g, '');

  if (allDigits.length < 6) {
    return {
      isValid: false,
      errorMessage: `Phone number is too short. Please enter a valid number for ${countryInfo.name}.`
    };
  }

  // Determine local/national digits (strip dial code if user or component included it)
  let localDigits = allDigits;
  if (allDigits.startsWith(dialDigits) && allDigits.length > dialDigits.length) {
    localDigits = allDigits.slice(dialDigits.length);
  }

  // Reject dummy repeating numbers: e.g. 00000000, 11111111, 2222222, 9999999
  if (/^(\d)\1+$/.test(localDigits) || /^(\d)\1+$/.test(allDigits)) {
    return {
      isValid: false,
      errorMessage: 'Please enter a genuine phone number. Repeating digits (e.g. 00000000, 11111111) are not allowed.'
    };
  }

  // Reject ascending/descending sequential dummy numbers: e.g. 123456, 1234567, 12345678, 0123456789
  const exactDummies = [
    '123456', '1234567', '12345678', '123456789', '1234567890',
    '012345', '0123456', '01234567', '012345678', '0123456789',
    '987654', '9876543', '98765432', '987654321', '9876543210',
    '876543', '8765432', '87654321', '765432', '7654321', '654321',
    '121212', '123123', '12341234'
  ];
  if (
    exactDummies.includes(localDigits) ||
    exactDummies.includes(allDigits) ||
    localDigits.startsWith('1234567') ||
    localDigits.startsWith('0123456') ||
    localDigits.startsWith('9876543')
  ) {
    return {
      isValid: false,
      errorMessage: 'Please enter your actual phone number. Sequential dummy numbers (e.g. 123456...) are not allowed.'
    };
  }

  const iso = countryInfo.iso2;

  // 1. Bangladesh (BD)
  if (iso === 'bd') {
    let bd = localDigits;
    if (bd.startsWith('0')) {
      bd = bd.slice(1);
    }
    // National mobile number in BD is 10 digits starting with 13-19 (or landline 2...)
    if (bd.length !== 10 || !/^1[3-9]\d{8}$/.test(bd)) {
      return {
        isValid: false,
        errorMessage: 'For Bangladesh, please enter a valid 11-digit mobile number starting with 01 (e.g., 01712-345678).'
      };
    }
    return {
      isValid: true,
      cleanedFullNumber: `+880 0${bd}`,
      nationalNumber: `0${bd}`
    };
  }

  // 2. United States / Canada (US / CA)
  if (iso === 'us' || iso === 'ca') {
    let nanp = localDigits;
    if (nanp.length === 11 && nanp.startsWith('1')) {
      nanp = nanp.slice(1);
    }
    if (nanp.length !== 10) {
      return {
        isValid: false,
        errorMessage: `For ${countryInfo.name}, please enter a valid 10-digit phone number with area code (e.g., 202-555-0143).`
      };
    }
    // NANP area code cannot start with 0 or 1; exchange code cannot start with 0 or 1
    if (/^[01]/.test(nanp) || /^\d{3}[01]/.test(nanp)) {
      return {
        isValid: false,
        errorMessage: 'US/Canada phone numbers cannot have area or exchange codes starting with 0 or 1.'
      };
    }
    return {
      isValid: true,
      cleanedFullNumber: `+1 ${nanp.slice(0, 3)}-${nanp.slice(3, 6)}-${nanp.slice(6)}`,
      nationalNumber: nanp
    };
  }

  // 3. United Kingdom (GB)
  if (iso === 'gb') {
    let uk = localDigits;
    if (uk.startsWith('0')) uk = uk.slice(1);
    if (uk.length < 9 || uk.length > 10) {
      return {
        isValid: false,
        errorMessage: 'For United Kingdom, please enter a valid 10-11 digit phone number (e.g., 07911 123456).'
      };
    }
    return {
      isValid: true,
      cleanedFullNumber: `+44 ${uk}`,
      nationalNumber: uk
    };
  }

  // 4. India (IN)
  if (iso === 'in') {
    let ind = localDigits;
    if (ind.startsWith('0')) ind = ind.slice(1);
    if (ind.length !== 10 || !/^[6-9]\d{9}$/.test(ind)) {
      return {
        isValid: false,
        errorMessage: 'For India, please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9 (e.g., 98765 43210).'
      };
    }
    return {
      isValid: true,
      cleanedFullNumber: `+91 ${ind}`,
      nationalNumber: ind
    };
  }

  // 5. United Arab Emirates (AE)
  if (iso === 'ae') {
    let ae = localDigits;
    if (ae.startsWith('0')) ae = ae.slice(1);
    if (ae.length !== 9 || !/^5\d{8}$/.test(ae)) {
      return {
        isValid: false,
        errorMessage: 'For UAE, please enter a valid 9-digit mobile number starting with 5 (e.g., 50 123 4567).'
      };
    }
    return {
      isValid: true,
      cleanedFullNumber: `+971 ${ae}`,
      nationalNumber: ae
    };
  }

  // 6. Saudi Arabia (SA)
  if (iso === 'sa') {
    let sa = localDigits;
    if (sa.startsWith('0')) sa = sa.slice(1);
    if (sa.length !== 9 || !/^5\d{8}$/.test(sa)) {
      return {
        isValid: false,
        errorMessage: 'For Saudi Arabia, please enter a valid 9-digit mobile number starting with 5 (e.g., 51 234 5678).'
      };
    }
    return {
      isValid: true,
      cleanedFullNumber: `+966 ${sa}`,
      nationalNumber: sa
    };
  }

  // 7. General fallback for all other countries
  if (localDigits.length < 7 || localDigits.length > 13) {
    return {
      isValid: false,
      errorMessage: `Please enter a valid phone number for ${countryInfo.name} (7-13 digits).`
    };
  }

  return {
    isValid: true,
    cleanedFullNumber: `${countryInfo.dialCode} ${localDigits}`,
    nationalNumber: localDigits
  };
}
